export const convertToOccasions = (occasions = [], messages = []) => {
  return occasions.reduce((acc, occasion, i) => {
    const ms = messages[occasion.value].reduce((acc, m) => {
      return acc.concat(m.map((m1) => ({
        isSelected: false,
        text: m1.text
      })));
    }, []);

    return acc.concat([{
      isSelected: i === 0,
      title: occasion.label,
      messages: ms
    }]);
  }, [])
}
